import { RouteComponentProps, RouteProps } from 'react-router';
import { PublicAppmarketPage } from './pages/PublicAppmarket';
import { AppDetailsPage } from './pages/AppDetails';
import { CategoryDetailsPage } from './pages/CategoryDetails';
import { CollectionDetailsPage } from './pages/CollectionDetails';
import { DeveloperDetailsPage } from './pages/DeveloperCollectionDetails';
import { AppSearchResults } from './pages/AppSearchResults';
import { NotFound } from './pages/NotFound';
import * as React from 'react';
import { AppMode } from './models/enums';
import { MyApps } from './pages/MyApps';

export enum AppMarketPageIdentifier {
  Home = '',
  Categories = 'categories',
  Collections = 'collections',
  AppDetails = 'apps',
  SearchedApps = 'search',
  DeveloperApps = 'developer',
  MyApps = 'myapps',
  MerchantPlans = 'plans'
}

export interface AppMarketRouteComponentProps extends RouteComponentProps<any> {
  routes?: AppMarketRoute[],
  appMode?: AppMode
}

export interface AppMarketRoute extends RouteProps {
  isUsOnly?: boolean;
  privateRouteOnly?: boolean;
  routes?: AppMarketRoute[];
  component?: React.ComponentType<AppMarketRouteComponentProps> | React.ComponentType<any>;
}

/**
 * Centralized config for the routes in App market, all the routes here are read in the AppMarketRouter component
 * This config can also take subroutes for a route eg:
 {path: `/${AppMarketPageIdentifier.AppDetails}/:appId`,
   component: AppDetailsPage,
   routes: [{path: 'updates',component: AppUpdatesComponent}]
  }
 * these subroutes can be used to create another switch in the entry component of the main route
 */
export const APP_MARKET_ROUTES: AppMarketRoute[] = [
  {
    path: '',
    component: PublicAppmarketPage,
    exact: true,
  },
  {
    path: `/${AppMarketPageIdentifier.AppDetails}/:appId`,
    component: AppDetailsPage,
  },
  {
    path: `/${AppMarketPageIdentifier.Categories}/:categoryId/:filterKey?`,
    component: CategoryDetailsPage,
  },
  {
    path: `/${AppMarketPageIdentifier.Collections}/:collectionId/:filterKey?`,
    component: CollectionDetailsPage,
  },
  {
    path: `/${AppMarketPageIdentifier.DeveloperApps}/:developerId/:filterKey?`,
    component: DeveloperDetailsPage,
  },
  {
    path: `/${AppMarketPageIdentifier.SearchedApps}/:searchStr/:filterKey?`,
    component: AppSearchResults,
  },
  {
    path: `/${AppMarketPageIdentifier.MyApps}/:filterKey?`,
    component: MyApps,
    privateRouteOnly: true,
  },
  {
    path: '*',
    component: NotFound,
  },
];
